<!--
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-07-18 14:42:18
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2023-01-29 18:39:31
 * @FilePath: \ioc_base\src\modules\carAccessRecord\pages\Home.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="section-main__warp">
    <router-view></router-view>
  </div>
</template>
<script>
export default {}
</script>
<style scoped>
.personAce {
    width: 100%;
    height: 100%;
}
</style>